import LightGlow_White from '../assets/graphics/png/animations/light_glow_white_ani.png';
import LightGlow_Yellow from '../assets/graphics/png/animations/light_glow_yellow_ani.png';
import SelectWordGuide_Handwriting from '../assets/graphics/webp/SelectWordGuide_Handwriting.webp';
import SelectWordGuide_QuickMemory from '../assets/graphics/webp/SelectWordGuide_QuickMemory.jpg';
import SelectWordGuide_Spelling from '../assets/graphics/webp/SelectWordGuide_Spelling.webp';

export enum SequenceImageType {
  QuickMemory = 'QuickMemory',
  Spelling = 'Spelling',
  Handwriting = 'Handwriting',
  WhiteLightGlow = 'WhiteLightGlow',
  YellowLightGlow = 'YellowLightGlow',
}

interface ImageSequenceConfig {
  imageStrip: string;
  totalFrames: number;
  interval: number; // Duration in milliseconds
  aspectRatio: number;
}

export const SequenceImages: Record<SequenceImageType, ImageSequenceConfig> = {
  [SequenceImageType.QuickMemory]: {
    imageStrip: SelectWordGuide_QuickMemory,
    totalFrames: 6,
    interval: 1000,
    aspectRatio: 350 / 250,
  },
  [SequenceImageType.Spelling]: {
    imageStrip: SelectWordGuide_Spelling,
    totalFrames: 6,
    interval: 1000,
    aspectRatio: 350 / 250,
  },
  [SequenceImageType.Handwriting]: {
    imageStrip: SelectWordGuide_Handwriting,
    totalFrames: 6,
    interval: 1000,
    aspectRatio: 350 / 250,
  },
  [SequenceImageType.WhiteLightGlow]: {
    imageStrip: LightGlow_White,
    totalFrames: 4,
    interval: 240,
    aspectRatio: 1,
  },
  [SequenceImageType.YellowLightGlow]: {
    imageStrip: LightGlow_Yellow,
    totalFrames: 6,
    interval: 160,
    aspectRatio: 1,
  },
};
